import { Outlet } from 'react-router-dom'
import './Section.css'
import './GuestManager/GuestActions.css'

function GuestManager() {
  return (
    <div className="dashboard-section">
      <Outlet />
    </div>
  )
}

export default GuestManager
